import React from 'react'
import { NavLink } from 'react-router-dom';

export const MainData = ({fatherid, id, count_id, name, status_approved, url}) => {

    return (
        <div key={id} className={(id===count_id)?"btn-unit":(status_approved==="pendiente")?"btn-unit-main-on":"btn-unit"}>
                <NavLink 
                to={`${url}/${fatherid}/${id}`} 
                    className="lkn-next wfp--link"
                >
                    <div className="btn-unit-text">
                    {name}
                    </div>
                    <div className={(id===count_id)?"btn-unit-pending":(status_approved==="pendiente")?"btn-unit-on":"btn-unit-ok"}></div>
                        

                </NavLink>
        </div>
    )
}
